import { useCallback } from "react";

export const useSortOrder = (
  request: any,
  setRequest: React.Dispatch<React.SetStateAction<any>>,
) => {
  const onSortChange = useCallback(
    (sorter: any, request: any) => {
      const newRequest = { ...request };
      if (!sorter.order) {
        delete newRequest["order"];
      } else {
        if (sorter.field === "name") {
          newRequest["order"] = sorter.order === "ascend" ? 0 : 1;
        }

        if (sorter.field === "contractNumber") {
          newRequest["order"] = sorter.order === "ascend" ? 2 : 3;
        }

        if (sorter.field === "createdBy") {
          newRequest["order"] = sorter.order === "ascend" ? 4 : 5;
        }

        if (sorter.field === "sentAt") {
          newRequest["order"] = sorter.order === "ascend" ? 6 : 7;
        }

        if (sorter.field === "assign") {
          newRequest["order"] = sorter.order === "ascend" ? 8 : 9;
        }
      }

      setRequest(newRequest);
    },
    [setRequest],
  );

  const onSorterChange = (_pagination: any, _filter: any, sorter: any) => {
    onSortChange(sorter, request);
  };

  return { onSorterChange };
};
